import {useContext} from 'react'
import { FeatureFlagsContext } from 'context/content-context';

export function CheckFlags(flag: String):boolean {
  const featureFlags = useContext(FeatureFlagsContext)
  flag = flag.trim()
  //determine if ! is in flag
  if (flag[0] === '!') {
    let check = flag.slice(1)
    let featureFound = featureFlags.find(ff => {
      return ff.featureName === check
    })
    return !featureFound || featureFound.status === 'disabled' ? true : false
  }
  //no ! in flag
  let featureFound = featureFlags.find(ff => {
    return ff.featureName === flag
  })

  return featureFound && featureFound.status === 'enabled' ? true : false

}